<script>
import axios, { AxiosResponse } from 'axios';
import Vue from 'vue';

export default class MulesoftCoreService extends Vue {
// Validation for new Mulesoft Core Configs
  static validateCoreJson(jsonData, coreNames) {
    const errors = [];

    if (!Object.prototype.hasOwnProperty.call(jsonData, 'version')) {
      errors.push('Please include \'version\'.');
    }

    if (Object.prototype.hasOwnProperty.call(jsonData, 'coreName')) {
      if (coreNames.includes(jsonData.coreName)) {
        errors.push(`coreName: ${jsonData.coreName} already exists.`);
      }
    } else {
      errors.push('Please include \'coreName\'.');
    }
    return errors;
  }

  static updateMulesoftCore(jsonPayload) {
    axios.put('/api/mulesoftcore/updateCores/', jsonPayload)
      .then((data) => {
      })
      .catch((error) => {
        alert('User does not have proper authority to update cores! Error: ', error);
      });
  }

  static getAllMulesoftCores() {
    const response = axios.get('/api/mulesoftcore/getAllCores').then((res) => {
      if (res.data) {
        return res.data;
      }
      return [];
      // Returns empty array if the back-end call pulls data from an empty table
    });
    return response;
  }

  static getMulesoftCoresByVersion(version) {
    const response = axios.get(`/api/mulesoftcore/mulesoft/core/${version}`).then(res => res.data);
    return response;
  }

  static getAllMulesoftCoreVersions() {
    const response = axios.get('/api/mulesoftcore/versions').then(res => [...new Set(res.data)]);
    return response;
  }

  static getMulesoftConfig(version, coreName) {
    const coreConfig = axios.get(`/api/mulesoftcore/mulesoft/core/${version}/${coreName}`)

      .then((data) => {
        console.log(data);
        const { config } = data.data;
        const keys = Object.keys(config);
        const values = Object.values(config);
        for (let i = 0; i < keys.length; i += 1) {
          if (this.isJsonString(values[i])) {
            config[keys[i]] = JSON.parse(values[i]);
          }
        }
        return config;
      });

    return coreConfig;
  }

  static isJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
}
</script>
